/* Copyright (C) 2020 Soil Capital Belgium SPRL - All Rights Reserved */
import { LOGIN, LOGIN_PAGE_UNLOADED, ASYNC_START } from "../constants/actionTypes";

const Auth = (state = {}, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        inProgress: false,
        errors: action.error ? action.payload : null,
      };
    case LOGIN_PAGE_UNLOADED:
      return {};
    case ASYNC_START:
      if (action.subtype === LOGIN) {
        return { ...state, inProgress: true };
      }
      break;
    default:
      return state;
  }

  return state;
};

export default Auth;
